import { render } from "./SearchAssessmentTypeFilter.vue?vue&type=template&id=3b992f8c"
import script from "./SearchAssessmentTypeFilter.vue?vue&type=script&lang=js"
export * from "./SearchAssessmentTypeFilter.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__